//import { QueovalBase } from 'projects/lib-components/src/public_api';

import { QueovalBase } from "../../models";
import { QuestionnaireState } from "../apprenant/apprenant.component";

export class StageQuestionnaireModel extends QueovalBase {
  stages: Array<Stage>;
  constructor() {
    super();
    this.stages = [];
  }
}

class Stage {
  ident: string;
  name: string;
  numStage: string;
  type: string;
  dated: string;
  datef: string;
  questionnaires: Array<Questionnaire>;

  constructor() {
    this.ident = '';
    this.questionnaires = [];
  }
}

class Questionnaire {
  model: string;
  type: string;
  titre: string;
  propName: string;
  note: number;
  noteMax: number;
  notePassage: number;
  isChecked: boolean;
  questValid: boolean;


  isCertification: boolean;
  timed: boolean;
  timesUp: boolean;

  unlockDate: Date;
  timeLocked: boolean;
  questionnaireState: QuestionnaireState;
}









export class DetailStageQuestionnaireModel extends QueovalBase {
  idStage: string;
  modelQuestionnaire: string;
  modelNameQuestionnaire: string;
  learnerList: Array<LearnerDetail>;
  listFormateur: Array<any>;
}

export class LearnerDetail {
  ident: string;
  name: string;
  firstname: string;
  questionnaireCompleted: boolean;
  note: number;
  noteMax: number;
  notePassage: number;
  isChecked: string;
  questValid: boolean;
  date: Date;
}
